import React, { useState } from "react";
import styled from "styled-components";

import deleteIcon from "../../assets/delete.svg";
import checkIcon from "../../assets/tick-green.svg";
import undoIcon from "../../assets/revert.svg";
import plusIcon from "../../assets/plus.svg";

function ToDo() {
	const [todos, setTodos] = useState([
		{ id: 1, text: "Buy 1 kg Tomato" },
		{ id: 2, text: "Buy 2kg Onion" },
		{ id: 3, text: "Visit friend" },
		{ id: 4, text: "Clean House" },
	]);

	const [completed, setCompleted] = useState([
		{ id: 5, text: "Washing Clothes" },
		{ id: 6, text: "Play Cricket" },
		{ id: 7, text: "1 km Walking" },
		{ id: 8, text: "Do Homework" },
	]);

	const [nextId, setNextId] = useState(9);
	const [input, setInput] = useState("");

	// ADD
	const addTodo = () => {
		if (input === "") return;

		const newTodo = {
			id: nextId,
			text: input,
		};

		setTodos([...todos, newTodo]);
		setNextId(nextId + 1);
		setInput("");
	};

	// COMPLETE
	const completeTodo = (id) => {
		let updated = [];
		let moved = null;

		for (let i = 0; i < todos.length; i++) {
			if (todos[i].id === id) moved = todos[i];
			else updated.push(todos[i]);
		}

		setTodos(updated);
		setCompleted([...completed, moved]);
	};

	// RESTORE (RETICK)
	const restoreTodo = (id) => {
		let updated = [];
		let moved = null;

		for (let i = 0; i < completed.length; i++) {
			if (completed[i].id === id) moved = completed[i];
			else updated.push(completed[i]);
		}

		setCompleted(updated);
		setTodos([...todos, moved]);
	};

	// DELETE
	const deleteTodo = (id, type) => {
		let updated = [];

		if (type === "todo") {
			for (let i = 0; i < todos.length; i++) {
				if (todos[i].id !== id) updated.push(todos[i]);
			}
			setTodos(updated);
		} else {
			for (let i = 0; i < completed.length; i++) {
				if (completed[i].id !== id) updated.push(completed[i]);
			}
			setCompleted(updated);
		}
	};

	return (
		<Wrapper>
			<Content>
				<Title>Todo List</Title>

				<Section>Things to be done</Section>

				{todos.map((todo) => (
					<Row key={todo.id}>
						<Left>
							<Circle onClick={() => completeTodo(todo.id)} />
							<Text>
								{todo.id}, {todo.text}
							</Text>
						</Left>

						<Icon
							src={deleteIcon}
							onClick={() => deleteTodo(todo.id, "todo")}
						/>
					</Row>
				))}

				{/* INPUT WITH PLUS ICON */}
				<InputRow>
					<PlusIcon src={plusIcon} onClick={addTodo} />

					<Input
						placeholder="Type new task..."
						value={input}
						onChange={(e) => setInput(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") addTodo();
						}}
					/>
				</InputRow>

				<Section>Completed</Section>

				{completed.map((todo) => (
					<Row key={todo.id}>
						<Left>
							<CheckCircle onClick={() => restoreTodo(todo.id)}>
								<img src={checkIcon} alt="" />
							</CheckCircle>

							<CompletedText>
								{todo.id}, {todo.text}
							</CompletedText>
						</Left>

						<Right>
							<Icon
								src={undoIcon}
								onClick={() => restoreTodo(todo.id)}
							/>
							<Icon
								src={deleteIcon}
								onClick={() => deleteTodo(todo.id, "completed")}
							/>
						</Right>
					</Row>
				))}
			</Content>
		</Wrapper>
	);
}

export default ToDo;

/* STYLES */

const Wrapper = styled.div`
	height: 100vh;
	background: #f9fafb;
	display: flex;
	justify-content: center;
`;

const Content = styled.div`
	width: 500px;
	padding: 50px 40px;
	border-left: 1px solid #d1d5db;
	border-right: 1px solid #d1d5db;
`;

const Title = styled.h1`
	text-align: center;
	font-size: 30px;
	margin-bottom: 40px;
`;

const Section = styled.h2`
	font-size: 20px;
	color: #1e1b4b;
	margin-bottom: 20px;
`;

const Row = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 22px;
`;

const Left = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;
`;

const Right = styled.div`
	display: flex;
	gap: 14px;
`;

const Circle = styled.div`
	width: 22px;
	height: 22px;
	border: 2px solid #1e1b4b;
	border-radius: 50%;
	cursor: pointer;
`;

const CheckCircle = styled.div`
	width: 22px;
	height: 22px;
	border: 2px solid #10b981;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	img {
		width: 12px;
	}
`;

const Text = styled.span`
	font-size: 16px;
`;

const CompletedText = styled.span`
	font-size: 16px;
	color: #10b981;
`;

const Icon = styled.img`
	width: 18px;
	cursor: pointer;
`;

const InputRow = styled.div`
	display: flex;
	align-items: center;
	margin: 30px 0 20px;
	border: 1px solid #d1d5db;
	padding: 12px;
	border-radius: 6px;
	background: white;
`;

const PlusIcon = styled.img`
	width: 18px;
	margin-right: 10px;
	cursor: pointer;
`;

const Input = styled.input`
	flex: 1;
	border: none;
	outline: none;
	font-size: 14px;
`;
